import { Injectable } from '@angular/core';
import { AjaxDataServiceService } from '@admin/core/ajax-data-service.service';
import { UrlConfigContainer } from '@admin/core/url-config';
import { UrlConfigService } from '@hrra/core';
import { PagingFilter } from '@admin/shared/models/paging-filter.model';
import { Observable } from 'rxjs';
import { PagingWrapper } from '@admin/core/models/paging-wrapper';
import { SliderBannerModel } from '@admin/product-purchases/shared/models/slider-banner-model';
import { SliderBannerRequestFilterModel } from '@admin/product-purchases/shared/models/slider-banner-request-filter-model';
import { SliderBannerRequestActionDataModel } from '@admin/product-purchases/shared/models/slider-banner-request-action-data';
import { SliderBannerRequestAction } from '@admin/product-purchases/shared/models/slider-banner-request-action';
import { EmptyData } from '@admin/core/models/empty-data';

@Injectable()
export class SliderBannerProductService {
  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}

  public listSliderBannerRequests(
    filter: PagingFilter<SliderBannerRequestFilterModel>
  ): Observable<PagingWrapper<SliderBannerModel>> {
    return this.ajax.postDataPaging(
      this.urlService.urlConfig.api.data.productPurchases.sliderbannerproduct.request.list,
      filter.toObject(),
      SliderBannerModel
    );
  }

  public approveSliderBannerRequest(request: SliderBannerModel) {
    let data = <SliderBannerRequestActionDataModel>{
      action: SliderBannerRequestAction.Approve,
      SliderBannerId: request.sliderBannerId,
    };

    var url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.sliderbannerproduct.request.process,
      { id: request.sliderBannerId }
    );
    return this.ajax.postData(url, data, EmptyData);
  }

  public rejectSliderBannerRequest(request: SliderBannerModel) {
    let data = <SliderBannerRequestActionDataModel>{
      action: SliderBannerRequestAction.Reject,
      SliderBannerId: request.sliderBannerId,
    };
    var url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.sliderbannerproduct.request.process,
      { id: request.sliderBannerId }
    );

    return this.ajax.postData(url, data, EmptyData);
  }

  public revokeSliderBannerRequest(bannerId: number, affectBilling: boolean) {
    let data = <SliderBannerRequestActionDataModel>{
      action: SliderBannerRequestAction.Revoke,
      SliderBannerId: bannerId,
      affectBilling: affectBilling,
    };
    var url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.sliderbannerproduct.request.process,
      { id: bannerId }
    );

    return this.ajax.postData(url, data, EmptyData);
  }

  public approveSliderBannerRequestWithModification(
    request: SliderBannerModel,
    newStoreItemId
  ) {
    let data = <SliderBannerRequestActionDataModel>{
      action: SliderBannerRequestAction.ApproveWithModification,
      SliderBannerId: request.sliderBannerId,
      newStoreItemId: newStoreItemId,
    };
    var url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.sliderbannerproduct.request.process,
      { id: request.sliderBannerId }
    );

    return this.ajax.postData(url, data, EmptyData);
  }
}
